// extracted by mini-css-extract-plugin
export default {"tech-item":"ProjectTechItem_tech-item__Zfw6E","tech-item__img":"ProjectTechItem_tech-item__img__QKsmv"};